import mutations from './follow-official-accounts-mutations';
import * as actions from './follow-official-accounts-actions';

export default {
  namespaced: true,
  state: {
    qrcode: '',
    qrcodeModalShow: false,
    closeDate: '',
    mp_watch: 0,
    isLogin: false,
    payok: false,
  },
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/follow-official-accounts/follow-official-accounts-store.js